<template>
    <div
        v-b-tooltip.hover
        class="fertilization-time"
        :title="$translate('time_since_fertilization')"
    >
        <span>{{ hours }} {{ $translate('h_hour') }}</span>
    </div>
</template>

<script>
export default {
    name: 'FertilizationTime',
    props: {
        hours: {
            type: Number,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.fertilization-time {
    display: flex;
    align-items: center;
    font-size: 10pt;
    color: $light-3;
    white-space: nowrap;
    font-weight: var(--font-weight-bold);
}
</style>
